// router.js
import { createRouter, createWebHashHistory } from "vue-router";
import CMSLogin from "@/pages/CMSPage/CMSLogin.vue";
import IndexHomePage from "@/pages/IndexHome.vue";
import IndexMainPage from "@/pages/IndexMain.vue";

// Routes
const routes = [
  {
    path: "/",
    name: "Login",
    component: CMSLogin,
    meta: {
      title: "Login",
      layout: "General",
      requiresAuth: false,
    },
  },
  {
    path: "/content/:module/:section",
    name: "IndexMainPage",
    component: IndexMainPage,
    meta: {
      main: "General Page",
      title: "General Section",
      subtitle:
        "Company-wide announcements and general information for all employees",
      layout: "Account",
      requiresAuth: true,
      roles: "all", // use 'all' and check against global GAZETTE_ROLES
    },
  },
  {
    path: "/home",
    name: "IndexHomePage",
    component: IndexHomePage,
    meta: {
      main: "General Page",
      title: "General Section",
      subtitle:
        "Company-wide announcements and general information for all employees",
      layout: "Account",
      requiresAuth: true,
      roles: "all",
    },
  },
];

// Router instance
const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

document.title = `IWC Gazette CMS`;

// Navigation guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const userType = localStorage.getItem("gazetteRole") || "";

  // Get the global roles array from main.js
  const roles = window.GAZETTE_ROLES || ["admin", "super", "moderator", "creator", "coordinator"];

  // Redirect logged-in user away from login page
  if (to.path === "/" && token) {
    next({ path: "/home" });
    return;
  }

  // Block unauthenticated access
  if (to.meta.requiresAuth && !token) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("gazetteRole");
    next({ path: "/" });
    return;
  }

  // Role check (allow if userType is in global roles array)
  if (Array.isArray(roles) && to.meta.requiresAuth) {
    if (!roles.includes(userType)) {
      next({ path: "/" });
      return;
    }
  }

  next();
});

export default router;